(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
function initializeHumbleRecommendationFocus() {
  const root = document.getElementById('pr_recommendations');
  if (!root || root.dataset.humbleFocusManaged) return;
  root.dataset.humbleFocusManaged = 'true';
  const synchronize = () => {
    root.querySelectorAll('[data-flickityjs] .pr_animated').forEach(cell => {
      cell.inert = cell.getAttribute('aria-hidden') === 'true';
    });
  };
  new MutationObserver(synchronize).observe(root, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
  synchronize();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeHumbleRecommendationFocus, { once: true });
} else {
  initializeHumbleRecommendationFocus();
}
document.addEventListener('shopify:section:load', initializeHumbleRecommendationFocus);

  } catch(e) { console.error(e); }
})();
})();
